// hooks/useMXP_LangSelect.js
import { useRef, useState } from "react";
import mixpanel from "mixpanel-browser";

export const useMXP_LangSelectModal = ({ lang, entryPoint }) => {
  const [languageChanged, setLanguageChanged] = useState(false);
  const [pageLoadTime] = useState(() => Date.now());
  const initialLangRef = useRef(lang);

  const onLangChange = (newLang) => {
    setLanguageChanged(newLang !== initialLangRef.current);
  };

  const trackProceed = () => {
    const timeSpent = Date.now() - pageLoadTime;

    mixpanel?.track("Language Selection", {
      "Entry Point": entryPoint,
      "Language Selected": lang,
      "Button Clicked": languageChanged
      ? "changed_language_proceed"
      : "default_language_proceed",
      "Time Spent to Proceed": timeSpent,
    });
    
  };

  return {
    onLangChange,
    trackProceed,
  };
};
